import { ArrowBackIos, ArrowForwardIos } from "@material-ui/icons";
import styled from "../../../../../config/emotion";

export const ModulesNavContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-left: 110px;
  margin-right: 220px;
`;

// this div is only for purpose of counting widths of modules in nav
export const HiddenModulesDiv = styled.div`
  visibility: hidden;
  position: fixed;
  top: -200px;
  display: flex;
  flex-direction: row;
`;

export const LeftArrow = styled(ArrowBackIos, {
  shouldForwardProp: (prop) => prop !== "isVisible",
})<{ isVisible: boolean }>`
  cursor: pointer;
  margin: auto 0.2em;
  color: ${({ theme: { colors } }) => colors.secondaryColor};
  display: ${(props) => (props.isVisible ? "inline-block" : "none")};

  :hover {
    color: ${({ theme: { colors } }) => colors.primaryColor};
  }

  @media (max-width: 990px) {
    display: none;
  }
`;

export const RightArrow = styled(ArrowForwardIos, {
  shouldForwardProp: (prop) => prop !== "isVisible",
})<{ isVisible: boolean }>`
  cursor: pointer;
  margin: auto 0.2em;
  color: ${({ theme: { colors } }) => colors.secondaryColor};
  visibility: ${(props) => (props.isVisible ? "visible" : "hidden")};
  //display: ${(props) => (props.isVisible ? "inline-block" : "none")};

  :hover {
    color: ${({ theme: { colors } }) => colors.primaryColor};
  }

  @media (max-width: 990px) {
    display: none;
  }
`;
